import { apiGet, apiPost, apiPut } from '@/shared/utils/requestBuilder';
import { InviteTenantPayload, UpdateEscritorioPayload } from '../types';

export interface ApiTenant {
  id: string;
  empresaId: string;
  nomeFantasia: string | null;
  razaoSocial: string;
  documento: string;
  subdominio: string | null;
  tipo: string;
  ownerUsuarioId: string | null;
  ativo: boolean;
  configuracoes: Record<string, unknown>;
  dataCriacao: string;
  dataAtualizacao: string;
  logotipo: string | null;
  pessoaId: string | null;
  contexto: string | null;
  site: string | null;
  _count: {
    usuarios: number;
    execucoes: number;
    categorias: number;
  };
  contracts?: { status: string; product: { name: string; periodicity: string | null } }[];
  usuarios?: { ultimoAcesso: string | null }[];
}

export const inviteTenantService = {
  inviteTenant: async (payload: InviteTenantPayload): Promise<void> => {
    const response = await apiPost('/onboarding/invite', payload);

    if (!response.ok) {
      const data = await response.json().catch(() => null);
      throw new Error(data?.error?.message || 'Erro na requisição');
    }
  },
};

export interface ListTenantsParams {
  search?: string;
  status?: string;
  page?: number;
  limit?: number;
}

export interface ListTenantsResponse {
  data: ApiTenant[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export const tenantsService = {
  listTenants: async (params?: ListTenantsParams): Promise<ListTenantsResponse> => {
    const queryParams: Record<string, string | number | boolean> = {};
    if (params?.search) queryParams.search = params.search;
    if (params?.status) queryParams.status = params.status;
    if (params?.page) queryParams.page = params.page;
    if (params?.limit) queryParams.limit = params.limit;

    const response = await apiGet('/escritorios', queryParams);
    const data = await response.json().catch(() => null);

    if (!response.ok) {
      throw new Error(data?.error?.message || 'Erro ao buscar empresas');
    }

    return data.data as ListTenantsResponse;
  },
};

export const escritorioService = {
  getById: async (id: string): Promise<ApiTenant> => {
    const response = await apiGet(`/escritorios/${id}`);
    const data = await response.json().catch(() => null);

    if (!response.ok) {
      throw new Error(data?.error?.message ?? data?.message ?? 'Erro ao carregar escritório');
    }

    const escritorio = data?.data ?? data;
    if (!escritorio) {
      throw new Error('Escritório não encontrado');
    }

    return escritorio as ApiTenant;
  },

  updateEscritorio: async (id: string, payload: UpdateEscritorioPayload): Promise<void> => {
    const response = await apiPut(`/escritorios/${id}`, payload);
    const data = await response.json().catch(() => null);

    if (!response.ok) {
      throw new Error(data?.error?.message || 'Erro ao atualizar escritório');
    }
  },
};
